class SaveCardController {
    constructor(savedCardService) {
        this.savedCardService = savedCardService;
    }

    $onInit() {
        this.cardSaved = false;
    }

    saveCard() {
        this.cardSaved = true;

        this.savedCardService.saveCardForOrder(this.orderId)
            .then(() => {
                delete this.error;
            })
            .catch(() => {
                this.cardSaved = false;
                this.error = 'There was an error saving your card.';
            });
    }
}

SaveCardController.$inject = ['SavedCardService'];

const saveCardComponentDefinition = {
    bindings: {
        orderId: '<',
        paymentType: '<',
    },
    controller: SaveCardController,
    template: require('./save-card.component.html').trim(),
};

module.exports = {
    SaveCardController,
    saveCardComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/savedcard/save-card.component.js